

































































import {Vue, Component, Watch} from 'vue-property-decorator';
import Number from '../../../../components/Number.vue';
import DetailStore from '@/store/DetailStore';
import lang2d from '../../../../utils/lang/lang-2d.js';
import HeaderQA from './header-qa.vue';

@Component({components: {Number, HeaderQA}})
export default class App extends Vue {
    lang:any = lang2d;
    detailData = DetailStore.state;
    get Relation () {return $foodConfig.mode === 'ces' ? '1856487352' : this.detailData.statisticInfo.Relation};
    get Entity () {return $foodConfig.mode === 'ces' ? '62994696221' : this.detailData.statisticInfo.Entity};
    get callCount () {
        return this.detailData.statisticInfo.callCount
                    .reverse().slice(3)
                    .map((item, index) => (
                        {
                            date: this.dateArr[index],
                            count:
                                item / Math.max.apply(null, this.detailData.statisticInfo.callCount) * 100
                        }
                    ))
    };
    dateArr: any;
    pvDay = 18062801;
    // callNumber = 145314311;
    callNumber = 0;
    callTimer = null;
    wrapDom:any = null;
    tip: any;
    screenType = window['_screenType'] || '1080';

    calcCallCount () {
        let baseDay:any= new Date('2019-01-01');
        let today:any = new Date();
        let day:any = (today - baseDay) / 1000 / 60 / 60 / 24;
        let countIncrease = parseInt('' + day * this.pvDay);
        this.callNumber += countIncrease;
    }

    created () {
        let subDay = d => new Date(d.getTime()-1000*60*60*24);

        let d = new Date();
        d = subDay(d);
        let dArr = [];
        for (let i = 0; i < 7; i++) {
            let month:any = d.getMonth()+1;
            let day:any = d.getDate();
            month = month < 10 ? ('' + '0' + month) : month;
            day = day < 10 ? ('' + '0' + day) : day;
            let t = month + '/' + day;
            dArr.push(t);
            d = subDay(d);
        }
        this.dateArr = dArr.reverse().slice(3);
        this.calcCallCount();
    }

    addTip () {
        this.tip = tippy('.header-data-inner');
    }

    random(min, max) {
        return parseInt('' + Math.floor(Math.random() * (max-min+1) + min));
    }

    mounted () {
        this.addTip();
        this.wrapDom = this.$refs.callNumber;
        let dom = document.createElement('div');
        dom.className = 'call-number-wrap-inner';
        this.wrapDom.appendChild(dom);

        let clock = new FlipClock($(dom), this.callNumber, {
            clockFace: 'Counter'
        });

        let perSecond = 209;
        let timeGap = 100;
        perSecond = timeGap / 1000 * 209;

        this.callTimer = setInterval(() => {
            this.callNumber += this.random(perSecond - perSecond/2, perSecond + perSecond/2);
            clock.setValue(this.callNumber);
        }, timeGap);
        if ($qsObj.force === 'true') {
            clearInterval(this.callTimer);
        }
    }

    splitNumber (value:any) {
        if(!value) return 0;

        let intPart = value.toString(); //获取整数部分
        return intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    }

    beforeDestroy () {
        this.tip.destroyAll();
        clearInterval(this.callTimer);
        this.wrapDom.innerHTML = '';
    }
}
